import {
  FaFacebook,
  FaGithub,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa";
import "./footer.css";

export default function Footer() {
  return (
    <>
      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/8801821647770"
        className="whatsapp-float"
        target="_blank"
        rel="noreferrer"
        title="Chat on WhatsApp"
      >
        <FaWhatsapp />
      </a>

      {/* Footer Section */}
      <footer className="footer">
        <div className="childF">
          <ul className="social" aria-label="Social media links">
            <li>
              <a
                href="https://web.facebook.com/rm.asadulla.web"
                title="Facebook"
                rel="noreferrer"
                target="_blank"
              >
                <FaFacebook className="sIcons" />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/rm-asadulla"
                title="LinkedIn"
                rel="noreferrer"
                target="_blank"
              >
                <FaLinkedin className="sIcons" />
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/Rm_Asadulla"
                title="Twitter"
                rel="noreferrer"
                target="_blank"
              >
                <FaTwitter className="sIcons" />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/asadulla.web.dev"
                title="Instagram"
                rel="noreferrer"
                target="_blank"
              >
                <FaInstagram className="sIcons" />
              </a>
            </li>
            <li>
              <a
                href="https://github.com/RMasadulla"
                title="Github"
                rel="noreferrer"
                target="_blank"
              >
                <FaGithub className="sIcons" />
              </a>
            </li>
          </ul>
          <p>&copy; {new Date().getFullYear()} || Asadulla Ahmed Ripon</p>
        </div>
      </footer>
    </>
  );
}
